import DualloDashboardClient from "@/clients/duallo/DualloDashboardClient";

class DashboardDataService {
    async getModelVersionSummaryById(assetId) {
        return await DualloDashboardClient.getModelVersionSummaryById(assetId);
    }
    
    async getNewestCommentsByAssetId(assetId) {
        return await DualloDashboardClient.getNewestCommentsByAssetId(assetId);
    }
}

export default new DashboardDataService();
